import * as Yup from 'yup';
import { Button, Col, Container, Row } from "react-bootstrap";
import { ErrorMessage, Field, Form, Formik } from 'formik';
import { useEffect, useState } from 'react';
import commissionService from '../../service/CommissionService';
import { ToastContainer, toast } from "react-toastify";

export const SettingManagement = () => {

  const commonSchema = Yup.object().shape({
    key: Yup.string()
      .required('Key is required'),
    threshold: Yup.number()
      .required('Threshold Amount is required')
      .typeError('Threshold Amount must be a number'),
    percentageBeforeThreshold: Yup.number()
      .required('Threshold % is required')
      .min(0, 'Min is 0%')
      .max(100, 'Max is 100%')
      .typeError('Threshold % must be a number'),
    percentageAfterThreshold: Yup.number()
      .required('Threshold % is required')
      .min(0, 'Min is 0%')
      .max(100, 'Max is 100%')
      .typeError('Threshold % must be a number'),
    minAmount: Yup.number()
      .required('Threshold Amount is required')
      .typeError('Threshold Amount must be a number'),
  });

  const get = (key) => {
    return {
      key: key,
      threshold: '',
      percentageBeforeThreshold: '',
      percentageAfterThreshold: '',
      minAmount : ''
    }
  }

  const [platformFee, setPlatformFee] = useState(get("PLATFORM_FEE"))
  const [validatorCommission, setValidatorCommission] = useState(get("VALIDATOR_COMMISSION"))

  useEffect(() => {
    commissionService.getAll().then(response => {
      const commissions = response.data.data.commission
      const platformFee_ = commissions.find(commission => commission.key=='PLATFORM_FEE')
      if(platformFee_) { setPlatformFee({...platformFee_,id:platformFee_._id}) }

      const validatorCommission_ = commissions.find(commission => commission.key=='VALIDATOR_COMMISSION')
      if(validatorCommission_) { setValidatorCommission({...validatorCommission_,id:validatorCommission_._id}) }
    })
  }, [])

  const update = async (data) => {
    let changed = true
    let label = "Commission "
    if(data.key=='PLATFORM_FEE') {
      changed = JSON.stringify(data) !== JSON.stringify(platformFee);
      label = "Platform fee "
    } else {
      changed = JSON.stringify(data) !== JSON.stringify(validatorCommission);
    }

    if(changed) {
      let response = null;
      if(data._id) { 
        response = await commissionService.update(data)
      } else {
        response = await commissionService.create(data)
      }
      
      if(response.status==200) {
        toast.success(`${label} updated successfully.`);
      }
    } else {
      toast.warning(`${label} is already updated.`);
    }
  };

  return (
    <>
      <div className="dashboard-main-area">
        <Container fluid>
          <div className="dashboard-area-heading management-heading">
            <Row className="row justify-content-center align-items-center mb-2">
              <Col md={12}>
                <div className="d-flex justify-content-between mb-2">
                  <div className="d-flex ">
                    <h2 className="align-self-center m-0">Fees & Commission</h2>
                  </div>
                </div>
              </Col>
            </Row>
            {/* under input area */}
            <div className="setting-area">
              <Row className="justify-content-center">
                <Formik
                  initialValues={platformFee}
                  enableReinitialize={true}
                  validationSchema={commonSchema}
                  onSubmit={update}
                >
                {() => (
                  <Col md={4}>
                    <Form>
                      <div className="setting-box">
                        <div className="under-setting main">
                          <p>Platform fee</p>
                        
                          <div className="under-bx">
                            <span>Threshold</span>
                            <div className="d-flex align-items-center flex-column gap-2">
                              <Field type="text" name="threshold" className="input-text" />
                              <ErrorMessage className='validation-error' name="threshold" component="div" />
                            </div>
                          </div>

                          <div className="under-bx">
                            <span>Before Threshold(%)</span>
                            <div className="d-flex align-items-center flex-column gap-2">
                              <Field type="text" name="percentageBeforeThreshold" className="input-text" />
                              <ErrorMessage className='validation-error' name="percentageBeforeThreshold" component="div" />
                            </div>
                          </div>
                          <div className="under-bx">
                            <span>After Threshold(%)</span>
                            <div className="d-flex align-items-center flex-column gap-2">
                              <Field type="text" name="percentageAfterThreshold" className="input-text" />
                              <ErrorMessage className='validation-error' name="percentageAfterThreshold" component="div" />
                            </div>
                          </div>

                          <div className="under-bx">
                            <span>Min Amount</span>
                            <div className="d-flex align-items-center flex-column gap-2">
                              <Field type="text" name="minAmount" className="input-text" />
                              <ErrorMessage className='validation-error' name="minAmount" component="div" />
                            </div>
                          </div>

                          <div className="d-flex justify-content-end w-100 mt-2">
                            <Button type='submit' variant="primary" style={{ backgroundColor: "#003FE6" }}>Update</Button>
                          </div>
                        </div>
                      </div>
                    </Form>
                  </Col>
                )}
                </Formik>

                <Formik
                  initialValues={validatorCommission}
                  enableReinitialize={true}
                  validationSchema={commonSchema}
                  onSubmit={update}
                >
                {() => (
                  <Col md={4}>
                    <Form>
                      <div className="setting-box">
                        <div className="under-setting main">
                          <p>Validator Commission</p>
                        
                          <div className="under-bx">
                            <span>Threshold</span>
                            <div className="d-flex align-items-center flex-column gap-2">
                              <Field type="text" name="threshold" className="input-text" />
                              <ErrorMessage className='validation-error' name="threshold" component="div" />
                            </div>
                          </div>

                          <div className="under-bx">
                            <span>Before Threshold(%)</span>
                            <div className="d-flex align-items-center flex-column gap-2">
                              <Field type="text" name="percentageBeforeThreshold" className="input-text" />
                              <ErrorMessage className='validation-error' name="percentageBeforeThreshold" component="div" />
                            </div>
                          </div>
                          <div className="under-bx">
                            <span>After Threshold(%)</span>
                            <div className="d-flex align-items-center flex-column gap-2">
                              <Field type="text" name="percentageAfterThreshold" className="input-text" />
                              <ErrorMessage className='validation-error' name="percentageAfterThreshold" component="div" />
                            </div>
                          </div>

                          <div className="under-bx">
                            <span>Min Amount</span>
                            <div className="d-flex align-items-center flex-column gap-2">
                              <Field type="text" name="minAmount" className="input-text" />
                              <ErrorMessage className='validation-error' name="minAmount" component="div" />
                            </div>
                          </div>

                          <div className="d-flex justify-content-end w-100 mt-2">
                            <Button type='submit' variant="primary" style={{ backgroundColor: "#003FE6" }}>Update</Button>
                          </div>
                        </div>
                      </div>
                    </Form>
                  </Col>
                )}
                </Formik>
              </Row>
            </div>
          </div>

        </Container>
      </div>
    </>
  );
};
